import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { Kbd } from '@/components/primitives';
import { INBOX_SHORTCUTS, SHORTCUT_GROUPS } from './keymap';

/**
 * Keyboard reference, generated from keymap.js. Radix Dialog: labelled,
 * focus trapped, Escape closes, focus returns to the trigger. Inbox.jsx
 * turns its own shortcuts off while this is open.
 */
export default function ShortcutHelp({ open, onOpenChange }) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="is-dialog-overlay" />
        <Dialog.Content className="is-dialog ib-help" data-testid="shortcut-help">
          <div className="ib-help-head">
            <Dialog.Title className="is-dialog-title">Keyboard shortcuts</Dialog.Title>
            <Dialog.Close className="is-icon-btn is-icon-btn--sm" aria-label="Close">
              <X aria-hidden="true" />
            </Dialog.Close>
          </div>
          <Dialog.Description className="is-dialog-body">
            Shortcuts work when focus is not in a text field. Actions apply to the selected brief.
          </Dialog.Description>
          <div className="ib-help-grid">
            {SHORTCUT_GROUPS.map((group) => (
              <section key={group}>
                <h3 className="ib-help-group">{group}</h3>
                <dl className="ib-help-list">
                  {INBOX_SHORTCUTS.filter((s) => s.group === group).map((s) => (
                    <div key={s.id} className="ib-help-row">
                      <dt>{s.combo ? <Kbd combo={s.combo} /> : <Kbd>{s.keys}</Kbd>}</dt>
                      <dd>{s.label}</dd>
                    </div>
                  ))}
                </dl>
              </section>
            ))}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
